import { Component, OnInit, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService } from '../../../_services/';
import * as _ from "lodash";
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';

// import { EventEmitter } from 'protractor';
// Algolia
import algoliasearch from 'algoliasearch';

const client = algoliasearch(environment.algolia.appId, environment.algolia.adminAPIKey);
const index = client.initIndex('contacts');


@Component({
  selector: 'app-add-new-user-dialog',
  templateUrl: './add-new-user-dialog.component.html',
  styleUrls: ['./add-new-user-dialog.component.scss']
})
export class AddNewUserDialogComponent implements OnInit {
  addNewUserForm:FormGroup;
  submitted = false;
  showSources:Boolean=false;
  showJobFunction:Boolean = false;
  showNickname:Boolean = false;
  errMsg:String = '';
  showroomList:any=[];
  contactTypes:any=[];
  contactSources:any=[];
  jobFunctionList:any=[];
  contactTypeId:String='';
  rs2Users:any[] =[];
  private subscription: Subscription;
  private subscription2: Subscription;
  constructor(
    public dialogRef: MatDialogRef<AddNewUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService
  ) { }

   ngOnInit() {
    this.showroomList = this.data.showroomList;
    this.jobFunctionList = this.data.jobFunctionList;
    this.addNewUserForm = this.fb.group({
      id: [null, []],
      json : [null,[]],
      first_name: [null, [  Validators.maxLength(50)]],
      last_name: [null, [ Validators.maxLength(50)]],
      email: [null, [Validators.required, Validators.email, Validators.maxLength(200)]],
      password: [null, [Validators.required, Validators.minLength (6)]],
      contact_type_id: ['', [Validators.required]],
      nickname: [null, [ Validators.maxLength(50)]],
      contact_source:['', []],
      is_technical_designer : ['', []],
      job_functions: this.buildJobFunctions(),
      showrooms: this.buildShowrooms()
    }) 
    this.getContactTypeList();
    this.getContactSourceList();
    
  }

  get showrooms() {
    return this.addNewUserForm.get('showrooms') as FormArray;
  };

  get job_functions() {
    return this.addNewUserForm.get('job_functions') as FormArray;
  };

  buildShowrooms() {
    
    const arr = this.showroomList.map((item) => {
      return this.fb.control(item.selected);
    }); 
    return this.fb.array(arr); 
  }

  buildJobFunctions() {
    
    const arr = this.jobFunctionList.map((item) => {
      return this.fb.control(item.selected);
    }); 
    return this.fb.array(arr); 
  }


  getContactTypeList(){
    // this._common.showLoader(true);
    this.subscription = this._admin.getContactTypeList().subscribe(result=>{
      // this._common.showLoader(false);
      this.contactTypes = result;
    },err=>{
      // this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  getContactSourceList(){
    this._common.showLoader(true);
    this.subscription2= this._admin.getContactSourceList().subscribe(result=>{
      this._common.showLoader(false);
      this.contactSources = result;
      // console.log(this.contactSources,'this is contact sourcesss-----');
    },err=>{
      // this._common.showLoader(false);
      this._alert.error('Something went wrong!');
    })
  }  

  showHideFields(event){
    this.showJobFunction = false;
    this.showSources = false;
    this.showNickname = false;
    this.contactTypeId = event.target.value;
    
    if(event.target.value==="staff"){
      this.showJobFunction = true;
    }
    else if(event.target.value==="lead"){
      
      this.showSources = true;
    }
    else if (event.target.value==="device"){
      this.showNickname = true;
    }
  }
  
  get fval() {
    return this.addNewUserForm.controls;
  }

  hideAddNewUserDialog(){
    this.dialogRef.close();
  }

  onFormSubmit():void {
    this.submitted = true;
    if (this.addNewUserForm.invalid) {
      return;
    } 
    let form = this.addNewUserForm.value;
    form.uid = localStorage.getItem('uid');
    this._common.showLoader(true);
    // Import code 
/*    form.ids = form.json;
    console.log('import data request sent!');
    this._admin.importRs2User(form).subscribe(res2 => {
      this._common.showLoader(false);
    },err=>{
      this._common.showLoader(false);
      this.errMsg = err.error.message;
      console.log(err ,'this is err message');
    }) */
    
   
    if(form.contact_type_id==="rs_2_import"){
      this.rs2Users = JSON.parse(form.json);
      for(let i=0; i<this.rs2Users.length;i++){
        this._admin.importRs2User(this.rs2Users[i].uid,'create_user').subscribe((res:any)=>{
          const data = {
            id : this.rs2Users[i].uid,
            user_id : this.rs2Users[i].uid,
            created : res.data.created,
            author_user_id : 1,
            email : res.data.mail,
            password : form.password,
            first_name : res.data.field_user_first_name.und[0].value,
            last_name : res.data.field_user_last_name.und[0].value,
            rs2_import : 'Yes',
            showrooms:[],
            rs2 : JSON.stringify(res.data),
            contact_type_id : form.contact_type_id
          }
          
          this._admin.createUser(data).subscribe(res2 => {
            if(res2 && res2.message){
              // Add data over Algolia
              const algoliaData = res.contactObj;
              algoliaData.objectID = res.contactObj.id;
              index.saveObjects([algoliaData], {
                autoGenerateObjectIDIfNotExist: true
              }).then(({ objectIDs }) => {})
              if(i+1 === this.rs2Users.length){
                this._common.showLoader(false);
                this.dialogRef.close();
                this._alert.success(res2.message);  
              }
            }
          },err=>{
            this._common.showLoader(false);
            this.errMsg = err.error.message
          })  

        }, err=>{
          this._common.showLoader(false);
          this.errMsg = err.error && err.error.message ? err.error.message : 'Something went wrong!';
        })
      }
    } else {
      
      const f = Object.assign({}, form, {
        showrooms: form.showrooms.map((s, i) => {
        return {
          name: this.showroomList[i].name,
          id: this.showroomList[i].id,
          selected: s
        }
      }),
      job_functions: form.job_functions.map((s, i) => {
        return {
          name: this.jobFunctionList[i].name,
          id: this.jobFunctionList[i].id,
          selected: s
        }
      })
      })
  
      // showroom data manipulation
      let oldShowrooms = f.showrooms.filter(doc=>{ if(doc.selected==true){ return doc}})
      form.showroom = [];
      for(let i = 0; i < oldShowrooms.length; i++) {
        form.showroom.push({"showroom_id":oldShowrooms[i].id});
      }
      // job function data manipulation
      let oldJobFunctions = f.job_functions.filter(doc=>{ if(doc.selected==true){ return doc}})
      form.job_functions = [];
      for(let i = 0; i < oldJobFunctions.length; i++) {
        form.job_functions.push(oldJobFunctions[i].id);
      }
      
      form.is_technical_designer = form.is_technical_designer == 1 ? true : false;
      form.is_technical_designer_active = form.is_technical_designer;
      this._admin.createUser(form).subscribe(res => {
        if(res && res.message){
          // Add data over Algolia
          const algoliaData = res.contactObj;
          algoliaData.objectID = res.contactObj.id;
          
          index.saveObjects([algoliaData], {
            autoGenerateObjectIDIfNotExist: true
          }).then(({ objectIDs }) => { });

          this._common.showLoader(false);
          this.dialogRef.close();
          this._alert.success(res.message);
        }
      },err=>{
        window.scroll({ 
          top: 0, 
          left: 0, 
          behavior: 'smooth' 
   });
        this._common.showLoader(false);
        this.errMsg = err.error.message
      })   
    }
    
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
  }
 

}
